"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightRepeatingEdit = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const Sub_1 = require("../../../Page/Title/Sub");
const ToggleSwitcher_1 = require("../../../ToggleSwitcher");
const RepeatingFirstDayEditor_1 = require("../components/RepeatingFirstDayEditor");
const RepeatingLastDayEditor_1 = require("../components/RepeatingLastDayEditor");
const RepeatingPeriodEditor_1 = require("../components/RepeatingPeriodEditor");
const RepeatingWeekdaysEditor_1 = require("../components/RepeatingWeekdaysEditor");
exports.className = 'flight-edit';
const descriptor = {
    firstDate: useForm_1.allDescriptors.string(),
    lastDate: useForm_1.allDescriptors.string(),
    period: useForm_1.allDescriptors.string(),
    weekdays: useForm_1.allDescriptors.object(),
};
const FlightRepeatingEdit = (props) => {
    const { config, propsValues, onChange, validateForm, setValidateRef, departure, isSequence, setIsSequence, } = props;
    const { fields, validateAll } = (0, useForm_1.useForm)({
        descriptor,
        config,
        propsValues,
        onChange,
        validateForm,
    });
    setValidateRef === null || setValidateRef === void 0 ? void 0 : setValidateRef(validateAll);
    return (react_1.default.createElement("div", { className: `${exports.className}__container` },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Repeating', defaultMessage: 'Repeating' }) }),
        react_1.default.createElement("div", { className: `${exports.className}__row` },
            react_1.default.createElement("div", { className: `${exports.className}__field` },
                react_1.default.createElement(ToggleSwitcher_1.ToggleSwitcher, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:IsSequence', defaultMessage: 'Is sequence flight' }), checked: isSequence, onChange: (e) => setIsSequence(e.target.checked) }))),
        isSequence && (react_1.default.createElement("div", { className: `${exports.className}__row ${exports.className}__row--repeating` },
            react_1.default.createElement("div", { className: `${exports.className}__field` },
                react_1.default.createElement("div", { className: 'form-fields-together' },
                    react_1.default.createElement(RepeatingFirstDayEditor_1.RepeatingFirstDayEditor, { field: fields.firstDate, disabledBeforeDay: departure }),
                    react_1.default.createElement(RepeatingLastDayEditor_1.RepeatingLastDayEditor, { field: fields.lastDate, disabledBeforeDay: departure }))),
            react_1.default.createElement("div", { className: `${exports.className}__field` },
                react_1.default.createElement("div", { className: 'form-fields-together form-fields-together--repeat-every' },
                    react_1.default.createElement(RepeatingPeriodEditor_1.RepeatingPeriodEditor, { field: fields.period }),
                    fields.period.value === 'week' && (react_1.default.createElement(RepeatingWeekdaysEditor_1.RepeatingWeekdaysEditor, { field: fields.weekdays, firstDay: fields.firstDate.value }))))))));
};
exports.FlightRepeatingEdit = FlightRepeatingEdit;
//# sourceMappingURL=index.js.map